import type { StateCreator } from 'zustand'
import { create } from 'zustand'
import { persist, PersistOptions } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export const createWithPersist = <T extends object>(
  state: StateCreator<T, [['zustand/persist', unknown]], []>,
  options: PersistOptions<T>,
) => {
  return create(persist(state, options))
}

export const createWithImmer = <T extends object>(
  state: StateCreator<T, [['zustand/immer', never]], []>,
) => {
  return create(immer(state))
}

export const createWithPersistAndImmer = <T extends object>(
  state: StateCreator<
    T,
    [['zustand/persist', unknown], ['zustand/immer', never]],
    []
  >,
  options: PersistOptions<T>,
) => {
  return create(persist(immer(state), options))
}
